import React from "react";

import { useVero1ReviewPanel } from "./context";
import { Vero1ReviewHandle } from "./Vero1ReviewHandle";
import { Vero1ReviewPanel } from "./Vero1ReviewPanel";

/**
 * Single mount point for the review panel, rendered above the router so the
 * review survives the agent moving between the deal's own pages (deal summary
 * and its application summaries). Renders nothing elsewhere — those pages
 * register no deal context — and nothing until a review has been opened.
 */
export const Vero1ReviewPanelHost = () => {
  const {
    dealId,
    currentDealId,
    dealLabel,
    isOpen,
    inDealContext,
    closeReview,
    exitReview,
    startPending,
  } = useVero1ReviewPanel();

  // The rail can show for an existing review on the deal's own pages before the
  // panel has ever been opened, so it keys off currentDealId, not the session.
  const showRail = currentDealId !== null && (inDealContext || dealId === null);

  if (!dealId && !showRail) {
    return null;
  }

  return (
    <>
      {dealId !== null && (
        <Vero1ReviewPanel
          dealId={dealId}
          dealLabel={dealLabel}
          visible={isOpen && inDealContext}
          onClose={closeReview}
          onExit={exitReview}
          startPending={startPending}
        />
      )}
      {showRail && <Vero1ReviewHandle />}
    </>
  );
};
